import React from "react";

const Button = ({
  varient,
  color,
  borderColor,
  className,
  children,
  disabled = false,
  ...restProps
}) => {
  const varients = {
    rounded: "rounded-full",
    primary: "rounded-lg",
    secondaryxl: "rounded-xl",
    secondary: "rounded-md",
  };

  const borderVarients = {
    blue: "border-2 border-blue-800",
    green: "border-2 border border-green-600",
    gray: "border-1 border border-gray-800",
  };

  const colorVariants = {
    white: "bg-white",
    blue: "bg-blue-800 hover:bg-blue-700",
    blue_600: "bg-blue-600",
    blue_800: "bg-blue-800",
    lightblue: "bg-blue-200",
    blue_300: "bg-blue-300",
    gray: "bg-gray-800",
    red: "bg-red-200",
    green :"bg-green-300"
  };

  return (
    <button
      type="button"
      {...restProps}
      disabled={disabled}
      className={`${varients[varient]} ${borderVarients[borderColor]} ${
        colorVariants[color]
      } ${className} ${disabled ? "cursor-no-drop" :"active:scale-95"}`}
    >
      {children}
    </button>
  );
};

export default Button;
